import React, { useState } from "react"
import SideContainerAnimated from "../SideContainer"
import SideForm from "../SideForm"
import { IDetail, IGroupFormEditDetails } from "./interface"
import pencil from "../../assets/icons/pencil.svg";
import { useQuery } from "react-query";
import { getDetails } from "../../hooks/getDetails";
import FormEditDetails from "../FormEditDetail";

const GroupFormEditDetails = ({
    isVisible,
    selectedProduct,
    formState,
    setRefresh
}: IGroupFormEditDetails
): React.ReactElement => {

    const [details, setDetails] = useState<Array<IDetail>>([]);

    useQuery(["getDetailProduct", isVisible], () => {
        getDetails(selectedProduct, setDetails)
    })

    return (
        <>
            <SideContainerAnimated isVisible={isVisible}>
                <SideForm
                    title="Editar variações"
                    icon={pencil}
                    sizeIcon={20}
                    visible={() => formState("close")}
                >   
                    { 
                        details.map((detail: IDetail, index: number) => {
                            return (
                                <FormEditDetails
                                    key={index}
                                    detail={detail}
                                    formState={formState}
                                    selectedProduct={selectedProduct}
                                    setRefresh={setRefresh}
                                />
                            )
                        }) 
                    }
                </SideForm>
            </SideContainerAnimated>
        </>
    )
}

export default GroupFormEditDetails